/**
 * Title-case a snake/dot-cased identifier and uppercase known acronyms.
 *
 * The naive `replace(/\b\w/g, c => c.toUpperCase())` produces "Lar Workspace
 * Deleted" and "Ai Performance Dashboard Viewed" — both flagged in QA. This
 * helper post-processes those into "LAR Workspace Deleted" / "AI Performance
 * Dashboard Viewed" without each callsite needing its own logic.
 *
 * Add new acronyms here as they appear in audit/activity event names.
 */
const ACRONYMS = [
  'LAR', 'HMDA', 'CRA', 'AI', 'MCP', 'MSA', 'FFIEC', 'CFPB', 'FDIC', 'OCC',
  'NCUA', 'HOEPA', 'HPML', 'NMLS', 'NMLSR', 'REMA', 'OFAC', 'BSA', 'AML', 'KYC',
  'ECOA', 'RESPA', 'TILA', 'FCRA', 'GLBA', 'NIST', 'CSA', 'OWASP', 'RBAC',
  'OAuth', 'MFA', 'SSO', 'API', 'URL', 'SQL', 'JSON', 'YAML', 'PDF', 'CSV',
  'XML', 'HTTP', 'HTTPS', 'TLS', 'SSL', 'IP', 'DNS', 'AWS', 'GCP', 'ID', 'UUID',
  'LO', 'IFLEP', 'APOR', 'CD', 'COI',
];

const ACRONYM_MAP: Record<string, string> = Object.fromEntries(
  ACRONYMS.map((a) => [a.toLowerCase(), a])
);

export function formatLabel(raw: string): string {
  if (!raw) return '';
  return raw
    .replace(/[._]/g, ' ')
    .replace(/\b\w+/g, (word) => {
      const lower = word.toLowerCase();
      if (ACRONYM_MAP[lower]) return ACRONYM_MAP[lower];
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    });
}
